import { createFileRoute, } from '@tanstack/react-router';
import { pick, } from 'remeda';
import { api, } from '../../../../api/Api.js';
export const Route = createFileRoute('/client/register')({
    validateSearch(search) {
        if (search.id && search.type) {
            return pick(search, ['id', 'type']);
        }
        throw new Error('Invalid search params for /client/register route');
    },
    loaderDeps: ({ search }) => search,
    async loader({ deps: search }) {
        return await api.client.register.requestTan.request({
            ...search,
            requestType: 'info',
        }, {
            retry: [0, 100, 500],
        });
    },
});
//# sourceMappingURL=ClientRegisterRoute.js.map